import React from 'react';
import classNames from 'classnames';
import { svgBaseProps, useInsertStyles, warning } from './utils';
const Icon = React.forwardRef((props, ref) => {
    const { 
    // affect outter <i>...</i>
    className, 
    // affect inner <svg>...</svg>
    component: Component, viewBox, spin, rotate, tabIndex, onClick, 
    // children
    children, ...restProps } = props;
    const { height, width } = restProps;
    warning(Boolean(Component || children), 'Should have `component` prop or `children`.');
    useInsertStyles();
    const classString = classNames('c7nicon', className);
    const svgClassString = classNames({
        'c7nicon-spin': !!spin,
    });
    const svgStyle = rotate
        ? {
            msTransform: `rotate(${rotate}deg)`,
            transform: `rotate(${rotate}deg)`,
        }
        : undefined;
    const innerSvgProps = {
        ...svgBaseProps,
        className: svgClassString,
        style: svgStyle,
        viewBox,
        height: height || svgBaseProps.height,
        width: width || svgBaseProps.width,
    };
    if (!viewBox) {
        delete innerSvgProps.viewBox;
    }
    // component > children
    const renderInnerNode = () => {
        if (Component) {
            return React.createElement(Component, Object.assign({}, innerSvgProps), children);
        }
        if (children) {
            warning(Boolean(viewBox) ||
                (React.Children.count(children) === 1 &&
                    React.isValidElement(children) &&
                    React.Children.only(children).type === 'use'), 'Make sure that you provide correct `viewBox`' +
                ' prop (default `0 0 1024 1024`) to the icon.');
            return (React.createElement("svg", Object.assign({}, innerSvgProps, { viewBox: viewBox }), children));
        }
        return null;
    };
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) {
        iconTabIndex = -1;
    }
    return (React.createElement("span", Object.assign({ role: "img" }, restProps, { ref: ref, tabIndex: iconTabIndex, onClick: onClick, className: classString }), renderInnerNode()));
});
Icon.displayName = 'SvgIcon';
Icon.__C7N_ICON = true;
export default Icon;
